module.exports = __webpack_public_path__ + "img/VetoSans-MediumItalic.00d6cfa0.svg";